export enum NotificationCycle {
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
    Yearly = 'yearly',
}

type GetManualNotificationResponse = Readonly<{
    id: number;
    admin_id: number | null;
    title: string;
    content: string;
    is_active: boolean;
    last_sent: string | null;
    start_date: string;
    cycle: NotificationCycle;
    cycle_days: number[] | null;
    left_to_deliver: number;
    end_date: string | null;
    deliver_time: string;
    pinned_hours: number;
    created_at: string | null;
    updated_at: string | null;
}>;

export default GetManualNotificationResponse;
